/**
 
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */
import { login } from '@/api/user'
import {
  getAccessToken,
  removeAccessToken,
  setAccessToken,
} from '@/utils/accessToken'
import { message } from 'ant-design-vue'
import Storage from 'good-storage'
const state = () => ({
  accessToken: getAccessToken(),
  username: '',
  avatar: '',
  netGroups: Storage.get('net-group-list') || '',
  currentNetGroup: Storage.get('net-group-id') || '',
  currentSystem: Storage.get('current-system') || 0,
})
const getters = {
  accessToken: (state) => state.accessToken,
  username: (state) => state.username,
  avatar: (state) => state.avatar,
  netGroups: (state) => state.netGroups,
  currentNetGroup: (state) => state.currentNetGroup,
  currentSystem: (state) => state.currentSystem,
}
const mutations = {
  /**
   
   * @description 设置accessToken
   * @param {*} state
   * @param {*} accessToken
   */
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
    setAccessToken(accessToken)
  },
  /**
   
   * @description 设置用户名
   * @param {*} state
   * @param {*} username
   */
  setUsername(state, username) {
    state.username = username
  },
  /**
   
   * @description 设置头像
   * @param {*} state
   * @param {*} avatar
   */
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  /**
   * @author mht 401285685@qq.com
   * @description 设置group列表
   */
  setNetGroups(state, groups) {
    state.netGroups = groups
    Storage.set('net-group-list', groups)
  },
  /**
   * @author mht 401285685@qq.com
   * @description 设置当前netGroupId
   */
  setCurrentNetGroup(state, group) {
    state.currentNetGroup = group
    Storage.set('net-group-id', group)
  },
  /**
   * @author mht 401285685@qq.com
   * @description 设置当前系统code
   */
  setCurrentSystem(state, code) {
    state.currentSystem = code
    Storage.set('current-system', code)
  },
}
const actions = {
  /**
   
   * @description 登录拦截放行时，设置虚拟角色
   * @param {*} { commit, dispatch }
   */
  setVirtualRoles({ commit, dispatch }) {
    dispatch('acl/setFull', true, { root: true })
    commit('setAvatar', 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif')
    commit('setUsername', 'admin(未开启登录拦截)')
  },

  async login({ commit }, userInfo) {
    const { token } = await login(userInfo)

    if (token) {
      commit('setAccessToken', token)
      localStorage.setItem('user-name', userInfo.username)
      return token
    } else {
      message.error(`登录接口异常，未正确返回token...`)
    }
  },
  /**
   
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({ commit, dispatch }) {
    const roles = ['admin']
    const ability = ['READ', 'WRITE', 'DELETE']
    const username = localStorage.getItem('user-name')

    if (username && roles && Array.isArray(roles)) {
      dispatch('acl/setRole', roles, { root: true })
      if (ability && ability.length > 0)
        dispatch('acl/setAbility', ability, { root: true })
      commit('setUsername', username)
      commit('setAvatar', '')
    } else {
      message.error('用户信息接口异常')
    }
  },

  /**
   
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({ dispatch }) {
    await dispatch('resetAll')
  },
  /**
   
   * @description 重置accessToken、roles、ability、router等
   * @param {*} { commit, dispatch }
   */
  async resetAll({ dispatch }) {
    await dispatch('setAccessToken', '')
    await dispatch('setCurrentNetGroup', '')

    await dispatch('acl/setFull', false, { root: true })
    await dispatch('acl/setRole', [], { root: true })
    await dispatch('acl/setAbility', [], { root: true })
    removeAccessToken()
  },
  /**
   
   * @description 设置token
   */
  setAccessToken({ commit }, accessToken) {
    commit('setAccessToken', accessToken)
  },
}
export default { state, getters, mutations, actions }
